import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PLANS = [{ id: "3d", days: 3, cost: 10 }, { id: "7d", days: 7, cost: 20 }];

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });

export const SponsorCard = () => {
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState("");
  const active = user.sponsored_until && new Date(user.sponsored_until) > new Date();

  const buy = async (plan) => {
    setLoading(plan.id);
    try {
      const r = await api.post("/profile/sponsor", { plan: plan.id });
      setUser(r.data);
      toast.success(`Profilo in evidenza fino al ${fmt(r.data.sponsored_until)}`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(""); }
  };

  return (
    <section className="mt-12 border border-[#D4AF37]/30 bg-[#121418] p-8 shadow-[0_0_25px_rgba(212,175,55,0.08)]" data-testid="sponsor-card">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="max-w-lg">
          <p className="eyebrow flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> Profilo in evidenza</p>
          <h2 className="font-serif text-3xl mt-3">Appari per prima nelle ricerche</h2>
          <p className="text-sm text-neutral-400 mt-3">
            {active ? <>Il tuo profilo è in evidenza fino al <span className="text-[#D4AF37]" data-testid="sponsor-active-until">{fmt(user.sponsored_until)}</span>. Puoi prolungarlo quando vuoi.</>
              : "Il tuo profilo comparirà in cima ai risultati, in qualsiasi ordinamento, con il badge \"In evidenza\"."}
          </p>
          <p className="text-xs font-mono text-neutral-500 mt-3" data-testid="sponsor-credits">Saldo: {user.credits ?? 0} crediti · <Link to="/crediti" className="text-[#D4AF37] hover:underline" data-testid="sponsor-buy-credits-link">Acquista crediti</Link></p>
        </div>
        <div className="grid grid-cols-2 gap-3 w-full sm:w-auto">
          {PLANS.map((p) => (
            <button key={p.id} onClick={() => buy(p)} disabled={!!loading || (user.credits ?? 0) < p.cost} data-testid={`sponsor-plan-${p.id}`}
              className="text-left border border-white/10 hover:border-[#D4AF37] disabled:opacity-40 disabled:hover:border-white/10 px-5 sm:px-6 py-5 sm:min-w-[150px] transition-colors">
              <p className="font-serif text-4xl">{p.days} <span className="text-lg">giorni</span></p>
              <p className="font-mono text-sm text-[#D4AF37] mt-1">{loading === p.id ? "Attivazione…" : `${p.cost} crediti`}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
